export default "__VITE_ASSET__Do1ixv0Z__"